import { useSelector } from "react-redux";

import { RootState } from "../store/store";

/** Tenant flag: event guest intake + browse people (Command Center). */
export function useEventIntakeEnabled(): boolean {
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const eventIntakeEnabled = useSelector((state: RootState) => state.config.eventIntakeEnabled);
  return configLoaded && eventIntakeEnabled;
}
